<div class="row">
  <div class="col-sm-6 col-lg grid-margin" *ngFor="let kpi of kpi_cards">
    <div class="card text-white h-100" style="background-color: #a15858db;"
      [attr.aria-label]="kpi.key + ', no value'">
      <div class="card-body">
        <h3 class="h4 mb-1">{{ kpi.value || '—' }}</h3>
        <p class="card-title text-white mb-0">{{ kpi.key }}</p>
      </div>
    </div>
  </div>
</div>